import { render, staticRenderFns } from "./robotSendP.vue.js?vue&type=template&id=5bba8d2b&scoped=true!=!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./robotSendP.vue?vue&type=template&id=5bba8d2b&scoped=true"
import script from "./robotSendP.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./robotSendP.vue?vue&type=script&lang=js"
export * from "./robotSendP.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./robotSendP.vue?vue&type=script&lang=js"
import style0 from "./robotSendP.vue.scss?vue&type=style&index=0&id=5bba8d2b&lang=scss&scoped=true!=!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./robotSendP.vue?vue&type=style&index=0&id=5bba8d2b&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bba8d2b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/web-hok_Mssh/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5bba8d2b')) {
      api.createRecord('5bba8d2b', component.options)
    } else {
      api.reload('5bba8d2b', component.options)
    }
    module.hot.accept("./robotSendP.vue.js?vue&type=template&id=5bba8d2b&scoped=true!=!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./robotSendP.vue?vue&type=template&id=5bba8d2b&scoped=true", function () {
      api.rerender('5bba8d2b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/live/liveRoom/components/Dialog/robotSendP.vue"
export default component.exports